export default __webpack_public_path__ + "static/media/000_intro_part2.hevc.1bec543d.mp4";